module.exports = __webpack_public_path__ + "img/btn-top.ae34cefe.png";